<template>
	<div class="row">
		<div class="col-md-6 col-md-offset-3">
			<div class="panel panel-custom">
				<div class="panel-heading">
					<i class="fa fa-calendar pull-right" style="margin-top:5px;"></i>
					<strong class="text-uppercase">ESCOLHA UMA DATA</strong>
				</div>

				<div class="list-group" v-if="agendas !== '' && agendas.length > 0">
					<template v-for="a in agendas">
						<router-link :to="`/agendas/${a.name}`" class="list-group-item">
							<span>{{ a.formated }}</span>
							<template v-if="a.observacao">
								<span class="label label-warning pull-right">indisponível</span>
							</template>
							<template v-else>
								<span class="label label-success pull-right" v-if="a.vagasDisponiveis > 0">
									<template v-if="a.vagasDisponiveis === 1">{{ a.vagasDisponiveis }} vaga disponível</template>
									<template v-if="a.vagasDisponiveis > 1">{{ a.vagasDisponiveis }} vagas disponíveis</template>
								</span>
								<span class="label label-warning pull-right" v-else>
									<template v-if="a.vagasDisponiveis === 0">sem vagas disponíveis</template>
								</span>
							</template>
						</router-link>
					</template>
				</div>

				<div class="panel-body" v-else>
					<div class="alert alert-warning" style="margin-bottom:0;">
						<strong>NENHUMA DATA DISPONÍVEL PARA AGENDAMENTO.</strong>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Moment from 'moment';
	import 'moment/locale/pt-br';
	import Agenda from 'models/agenda';

	export default {
		data() {
			return {
				agendas: ''
			};
		},

		async created() {
			this.agendas = await Agenda.getAll();

			this.agendas.forEach(a => {
				let data = Moment(a.data, 'DD/MM/YYYY');
				let vagasDisponiveis = a.horas.filter(h => h.status.id === 1).length;

				a.name = data.format('DD-MM-YYYY');
				a.formated = data.format('dddd, DD [de] MMMM [de] YYYY');
				a.observacao = a.observacao;
				a.vagasDisponiveis = vagasDisponiveis;
				a.disponivel = a.disponivel;
			});
		}
	};
</script>

<style scoped>
	.panel .list-group-item {
		font-size: 16px;
		text-transform: uppercase;
		color: inherit;
		padding: 20px 15px;
	}

	.panel .list-group-item:hover {
		background: lightgoldenrodyellow;
	}

	.panel .list-group-item .label {
		font-size: 11px;
		line-height: inherit;
		position: absolute;
		top: 10px;
		right: 10px;
	}

	/*smartphones*/
	@media (max-width: 767px) {
		.panel .list-group-item {
			padding: 25px 15px;
		}

		.panel .list-group-item .label {
			top: 5px;
			right: 5px;
		}
	}
</style>


// WEBPACK FOOTER //
// listar.vue?00a25684